import { isNone } from '@ember/utils';
import { ajax } from '@square/dashboard-utilities/utils/xhr';
import EmberDataBaseAdapter from '@square/dashboard-data/adapters/ember-data-base-adapter';
import multipartFormSerialize from '@square/dashboard-data/utils/multipart-form-serialize';
export default EmberDataBaseAdapter.extend({
  buildURL(modelName, id) {
    if (id) {
      return `/api/v1/merchant-profile/${id}?web=true`;
    }
    return '/api/v1/merchant-profile?web=true';
  },
  shouldSaveViaFormData(record) {
    const profileImage = record.get('profileImage');
    const profileBannerImage = record.get('profileBannerImage');
    return 'profileImage' in record.changedAttributes() && !isNone(profileImage) || 'profileBannerImage' in record.changedAttributes() && !isNone(profileBannerImage);
  },
  updateRecord(store, type, snapshot) {
    const record = snapshot.record;
    if (this.shouldSaveViaFormData(record)) {
      return this._submitRecordViaFormData(record, 'PUT');
    } else {
      return this._super(store, type, snapshot);
    }
  },
  createRecord(store, type, snapshot) {
    const record = snapshot.record;
    if (this.shouldSaveViaFormData(record)) {
      return this._submitRecordViaFormData(record, 'POST');
    } else {
      return this._super(store, type, snapshot);
    }
  },
  _submitRecordViaFormData(record, method) {
    const params = {
      type: method,
      data: this.toFormData(record),
      processData: false,
      contentType: false
    };
    const url = this.buildURL(record.constructor, record.token);
    return ajax(url, params);
  },
  toFormData(record) {
    const fd = new FormData();
    const payload = record.serialize();
    const nullableParts = [];
    if ('profileImage' in record.changedAttributes()) {
      nullableParts.push('entity.profile_image');
    }
    if ('profileBannerImage' in record.changedAttributes()) {
      nullableParts.push('entity.profile_banner_image');
    }
    multipartFormSerialize(payload, [], [], true, nullableParts).forEach(([key, value]) => fd.append(key, value));
    return fd;
  }
});